import { BaseResource } from "./base.resource";

export const ManagementCodeAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class ManagementCode extends BaseResource {
  active: boolean;
  code: string;
  description: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & ManagementCodeAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & ManagementCodeAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & ManagementCodeAccessLevel.Delete) > 0;
  }
}
